import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import PatientsFilter from './filterEntity';
import FilterModel from './filterModel';

import { Patients } from '@/models/patients';

export const MODULE_NAME = Patients.moduleName;

const filterModel = new FilterModel();
const filter = getModule(PatientsFilter);

filter.setFilterName('patientsFilter');
filter.setTemplateClassName('template-lg');
filter.setFilterModel(filterModel.filterModel);
filter.setFilterHandlers(filterModel.filterHandlers);

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PatientsModule extends PageBaseModule {
    filter = filter;

    constructor(module: PatientsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Patients.listTitle);
        page.setTitleAdd(Patients.createTitle);
        page.values.actionPagination = 'patients/updatePage';
        page.values.actionPageAmountItems = 'patients/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Patients.moduleName}_edit`;
        this.pageSettings.routeParam = `${Patients.moduleName}Id`;
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(Patients.moduleName,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,

            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(PatientsModule);